import React from 'react';
import _ from 'lodash';
import numeral from 'numeral';
// import Util from 'util/Util';

export default {

  cencoLinkifyContent ( content, imgConf={width:100} ){
    if (!content){
      return null;
    }
    let imgLinks = [];
    const imgExpression = /<img[^>]+src="?([^"\s]+)"?\s*[\/]?>/gi;
        
    while ( content.toLowerCase().indexOf('<img') !== -1){

      let matchImages = imgExpression.exec(content );
      if (matchImages){
        imgLinks.push(matchImages[1]);
        content = content.replace(matchImages[0], '');
      } else {
        break;
      }
    }

    const expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    const regex = new RegExp(expression);
    const chunks = content.split(' ');
    let chunks2 = [];
    chunks.map( ( chunc, idx) => {
      const obj2 = regex.exec(chunc )
      if ( obj2 ){
        chunks2.push({isLink: true, content: obj2[0] })
      } else {
        chunks2.push({isLink: false, content: chunc })
      }
    });
    
    return (
      <span>
          {chunks2.map( ( item, idx) => (
            (item.isLink
            ? <a key={idx} href={item.content} target="_blank" >{item.content ? item.content.substring(0,20): ''}...</a>
            : <span key={idx} >{item.content}{' '}</span>
            )
          )
          )}
          {imgLinks.map( ( item, idx) => (
            (item &&
              <a key={idx} href={item} target="_blank" ><img width={imgConf.width} src={item}  /></a>
            )
          )
          )}
      </span>
    )
  },

  cencoLinkifyContentEmail ( content ){
    if (!content){
      return null;
    }
    const expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
    const regex = new RegExp(expression);
    const chunks = content.split(' ');
    let chunks2 = [];
 
    return content.replace ('<a','<a target="_blank"');
  },

  formatCurrency( number, currency ) {
    if ( number === 0 ) return '$0';
    if ( !number ) return number;

    let format = '$0,0.[00]';
    if ( currency === 'EUR' ) {
      format = '0,0.[00] EUR';
    }

    return numeral( number ).format( format );
  },

  formatCurrencyNoDecimals( number, currency ) {
    if ( number === 0 ) return '$0';
    if ( !number ) return number;

    let format = '$0,0';
    if ( currency === 'EUR' ) {
      format = '0,0 EUR';
    }

    return numeral( number ).format( format );
  },
  formatNumber( number ) {
    if ( !number ) return number;
    if ( !_.isNumber( number ) ) return number;
    return numeral( number ).format( '0,0.[00]' );
  },

  formatNumberNoDecimals( number ) {
    if ( !number ) return number;
    if ( !_.isNumber( number ) ) return number;
    return numeral( number ).format( '0,0' );
  },
};



// WEBPACK FOOTER //
// ./util/Util.js